import React, {useEffect, useState} from 'react';

import PropTypes from 'prop-types';


import {AuthService} from "./service/AuthService";
import {LanguageService} from "./service/LanguageService";
import {getKeyValue, isAdmin, user} from "./utils/Utils";
import {usage_types, usageTypeMeta} from "./utils/Constants";
import {isMarketplaceOperatorCampaign, MARKETPLACE_OPERATOR_META} from "./components/Campaign/marketplaceOperatorSettings";
import UserGuiding from "./utils/UserGuiding";
import {Dropdown} from "primereact/dropdown";
import {Checkbox} from "primereact/checkbox";
import {AppContext} from "./HomePage";
import Contact from "./components/Account/Contact";
import {Button} from "primereact/button";
import {CampaignContext} from "./App";
import DownloadReport from "./components/Export/DownloadReport";
import SystemHealthBell from "./components/Admin/SystemHealthBell";

const AppTopbar  = (props) => {

    const {t, toast, host} = React.useContext(AppContext);
    const {campaigns, selectedCampaign, selectCampaign} = React.useContext(CampaignContext);

    // Tur (Start tour) özelliği eski ekranlara göre hazırlanmıştı; yeni ekranlara
    // göre tekrar implement edilene kadar geçici olarak kapatıldı. Açmak için
    // TOUR_ENABLED'ı true yapmak yeterli.
    const TOUR_ENABLED = false;

    const [showTourGlobe, setShowTourGlobe] = useState(false);
    const [isTourOpen, setIsTourOpen] = useState(false);
    const [tourPage, setTourPage] = useState("");

    useEffect ( ()=>{
        if (TOUR_ENABLED && showTourGlobe === false && ( window.location.hash === "#/campaign" || window.location.hash === "#/product"))
        {
            setShowTourGlobe(true);
            setTourPage(window.location.hash.replace("#/", ""));
        }
        else if (showTourGlobe === true && window.location.hash !== "#/campaign" && window.location.hash !== "#/product") {
            setShowTourGlobe(false);
            setTourPage(window.location.hash.replace("#/", ""));
        }

        if (host === "ecomscanner")
            setEn();
    },[]);


    const logout = () => {
        AuthService.logout();
    }

    const setEn = () =>{
        LanguageService.setLanguage("en");
    };

    // Campaign-type identity (Competitive / Brand Protection / Market Research /
    // Drop Shipping). Icon + color come from the shared usage_type_meta map.
    const campaignType = (c) => (c && c.settings && c.settings.usage_type) || (user() && user().usage_type);
    // Marketplace API campaigns (settings.marketplace_api present) pin
    // settings.usage_type to 'seller' (see CampaignEdit.js selectMarketplaceBuybox)
    // -- the dropdown chip must not read that as "Competitive"; it needs its own
    // branch ahead of the plain usage_type lookup below (mirrors Campaign.js
    // isMarketplaceBuybox).
    const isMarketplaceBuybox = (c) => !!(c && c.settings && c.settings.marketplace_api);
    const campaignTypeLabel = (c) => {
        if (isMarketplaceBuybox(c)) return t('campaign.usage_type_marketplace_buybox');
        if (isMarketplaceOperatorCampaign(c)) return t('campaign.usage_type_marketplace_operator');
        const ut = campaignType(c);
        const found = usage_types(t).find(x => x.value === ut);
        return found ? found.label : ut;
    };
    // Icon + background/color for the chip -- purple accent for Marketplace
    // Buybox (same #7c3aed/pi-shopping-bag as the campaign card), otherwise the
    // shared usage_type_meta map.
    const campaignTypeMeta = (c) => {
        if (isMarketplaceBuybox(c)) return {icon: 'pi pi-shopping-bag', color: '#fff', bg: '#7c3aed'};
        if (isMarketplaceOperatorCampaign(c)) return MARKETPLACE_OPERATOR_META;
        return usageTypeMeta(campaignType(c));
    };
    // Icon + label badge — used in the dropdown items (where there is room).
    const typeBadge = (c) => {
        const m = campaignTypeMeta(c);
        return <span style={{display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '.62rem', fontWeight: 700,
            padding: '1px 7px', borderRadius: 6, background: m.bg, color: m.color, textTransform: 'uppercase',
            letterSpacing: '.03em', whiteSpace: 'nowrap'}}>
            <i className={m.icon} style={{fontSize: '.66rem'}}/> {campaignTypeLabel(c)}</span>;
    };
    // Icon-only chip — used in the collapsed selected value to leave room for the
    // campaign name (the full label is on hover via title).
    const typeIconChip = (c) => {
        const m = campaignTypeMeta(c);
        return <span title={campaignTypeLabel(c)} style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 20, height: 20, borderRadius: 5, background: m.bg, color: m.color, flexShrink: 0}}>
            <i className={m.icon} style={{fontSize: '.72rem'}}/></span>;
    };
    const campaignItemTemplate = (c) => (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12}}>
            <span style={{fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{c.name}</span>
            {typeBadge(c)}
        </div>
    );
    const campaignValueTemplate = () => {
        const c = selectedCampaign;
        if (!c || !c.id) return <span style={{color: '#9ca3af'}}>{t('campaign.select', 'Select campaign')}</span>;
        return (
            <div style={{display: 'flex', alignItems: 'center', gap: 8, minWidth: 0}}>
                {typeIconChip(c)}
                <span style={{fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{c.name}</span>
            </div>
        );
    };

    return (
        <div className={"p-grid layout-topbar clearfix p-nogutter" + (host === "ecomscanner" ? " ecomscanner" : "")}>
            {showTourGlobe && <UserGuiding tourPage={tourPage} openTour={isTourOpen} closeTour={()=> {setIsTourOpen(false);}} />}
            <div className="p-col-fixed" style={{width:'15em'}}>
                {host === "ecomscanner" ? <img className="logo" alt="logo" src="/assets/layout/images/logo_ecomscanner.png" />:
                    <img className="logo" alt="logo" src="/assets/layout/images/logo_white.png" /> }

                <Button icon="pi pi-bars" className="p-link layout-menu-button p-button-text" onClick={props.onToggleMenu} />
            </div>
            <div className="p-col-fixed campaign-bar">
            {campaigns && campaigns.length > 1 &&
                <Dropdown id="state" name="state" className="campaignSelect" filter={campaigns.length > 10}
                          style={{verticalAlign:"inherit", marginLeft:"0.5em", minWidth:"17em", fontWeight:600}}
                          options={campaigns.sort((a, b) => (a.name ? a.name.toLowerCase() : "").localeCompare((b.name ? b.name.toLowerCase() : ""), undefined, {sensitivity: 'base'}))}
                          optionLabel="name" optionValue="id"
                          value={selectedCampaign ? selectedCampaign.id : null}
                          valueTemplate={campaignValueTemplate}
                          itemTemplate={campaignItemTemplate}
                          onChange={(e) => {selectCampaign(getKeyValue(e).value);}}
                />}
            </div>
            <div className="p-col"></div>
            <div className="p-col-fixed layout-topbar-actions">
                <div className="layout-topbar-icons">

                    {isAdmin() && <SystemHealthBell />}
                    <DownloadReport />

                    {showTourGlobe &&
                    <Button icon="pi pi-globe" className="p-button-text" onClick={() => {setIsTourOpen(true);}} tooltip={t('actions.start_tour')} tooltipOptions={{position: 'bottom'}}  />}

                    {/* Contact Us temporarily hidden (Tidio chat is used instead). To re-enable: true && <Contact /> */}
                    {false && <Contact />}

                    <Button icon="pi pi-user" className="p-button-text" onClick={() => {window.location = "#/account"}} tooltip={t('menu_item.account')} tooltipOptions={{position: 'bottom'}}  />

                    <Button icon="pi pi-power-off" className="p-button-text" onClick={logout} tooltip={t('actions.logout')} tooltipOptions={{position: 'bottom'}}  />

                    {isAdmin() &&
                        <Checkbox style={{marginBottom:"0.5em"}} value={isAdmin()} checked={isAdmin()} onChange={(e)=>{AuthService.changeIsAdmin()}}/>
                    }

                </div>
            </div>
        </div>
    );
}
AppTopbar.prototype = {
    onToggleMenu: PropTypes.func.isRequired
}
export default AppTopbar;
